<template>
  <v-form ref="form" v-model="validForm">
    <v-autocomplete
      v-model="asignacionId"
      @change="change"
      :items="asiganciones"
      item-text="nombre"
      item-value="id"
      dense
      filled
      label="Asignacion"
      :rules="[rules.required]"
    ></v-autocomplete>
   
  </v-form>
</template>
<script>
import axios from "axios";

export default {
  props: {
    filtro: { type: Array, default: null },
    id: {type: Number, default: null}
  },
  data() {
    return {
      asiganciones: [],
      asignacionId: null,
      validForm: false,
      rules: {
        required: (value) => !!value || "Requerido.",
        counter: (value) =>
          (value && value.length <= 1000) || "Maximo 100 caracteres",
        counter10: (value) =>
          (value && value.length <= 10) || "Maximo 10 caracteres",
      },
    };
  },
  mounted() {

    this.asignacionId = this.id;
    axios
      .get("/asignacion")
      .then((response) => {
        console.log(response);
        if (this.filtro) {
          this.asiganciones = response.data.filter((asig) =>
            this.filtro.includes(asig.id)
          );
        } else {
          this.asiganciones = response.data;
        }
      })
      .catch((err) => {
        console.log(err);
      });
  },
  methods: {
    change() {
      this.$emit('asignacionId', this.asignacionId)
    }
  }
};
</script>